import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  TranslationRequestBulDownloadInput,
  TranslationRequestBulDownloadPayload
} from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TranslationRequestBulDownloadInput;
type TData = TranslationRequestBulDownloadPayload;

export const useTranslationRequestBulkDownload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestBulkDownload($input: TranslationRequestBulDownloadInput!) {
      translationRequestBulkDownload(input: $input) {
        success
        guid
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
